import React, { ReactNode } from 'react';
import { CloseOutlineIcon } from 'cokitchen-icons';
import Modal, { Props } from 'react-modal';
import './style.scss';

type LocalSideModalProps = Props & {
  isOpen: boolean;
  onRequestClose: () => void;
  children: ReactNode;
  title?: ReactNode;
};

const customStyles = {
  content: {
    top: '80px',
    left: 'auto',
    right: '0%',
    bottom: 'auto',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    height: 'calc(100vh - 80px)',
    boxShadow: '0px 1px 20px 0px rgba(69, 75, 84, 0.20)',
    overflow: 'none'
  },
  overlay: {
    background: 'transparent',
    zIndex: 10000
  }
};

const LocalSideModal = ({
  isOpen,
  onRequestClose,
  children,
  title,
  ...modalProps
}: LocalSideModalProps) => {
  return (
    <Modal
      style={customStyles}
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick
      {...modalProps}>
      <div className='w-[98vw] sm:w-[450px] pt-7 px-[30px] sidemodal'>
        <div className='sidemodal__close' onClick={onRequestClose}>
          <CloseOutlineIcon />
        </div>

        {title ? title : <span />}
        <div className='overflow-y-scroll h-full pr-[30px]'>{children}</div>
      </div>
    </Modal>
  );
};

export default LocalSideModal;
